import { useState } from "react";
import supabase from '../supabaseClient';
import { NuevoEquipoModal } from './NuevoEquipoModal';

// ── ADMIN: INVENTARIO ────────────────────────────────────────────
export const InventarioSection = ({ equipos, setEquipos, currentUser }) => {
  const [equipoEdit, setEquipoEdit] = useState(null);
  const [modalNuevoEquipo, setModalNuevoEquipo] = useState(false);
  const [nuevoEquipo, setNuevoEquipo] = useState({ Nombre: "", Descripción: "", Marca: "", Modelo: "", Num_serie: "", Activo: true });

  const crearEquipo = async () => {
    try {
      const { data, error } = await supabase.from('Equipos').insert({ ...nuevoEquipo, almacen_id: currentUser?.almacen_id }).select();
      if (!error && data) {
        setEquipos(e => [...e, data[0]]);
        setModalNuevoEquipo(false);
        setNuevoEquipo({ Nombre: "", Descripción: "", Marca: "", Modelo: "", Num_serie: "", Activo: true });
      }
    } catch { }
  };

  const actualizarEquipo = async (eq) => {
    try {
      await supabase.from('Equipos').update({ Nombre: eq.Nombre, Descripción: eq["Descripción"], Marca: eq.Marca, Modelo: eq.Modelo, Num_serie: eq.Num_serie, Activo: eq.Activo }).eq('id', eq.id);
      setEquipos(e => e.map(x => x.id === eq.id ? eq : x));
      setEquipoEdit(null);
    } catch { }
  };

  const eliminarEquipo = async (eq) => {
    if (!window.confirm(`¿Eliminar "${eq.Nombre}" de forma permanente?`)) return;
    try {
      const { data, error } = await supabase.from('Equipos').delete().eq('id', eq.id).select();
      if (!error && data && data.length > 0) {
        setEquipos(e => e.filter(x => x.id !== eq.id));
      } else {
        window.alert(`No se pudo eliminar "${eq.Nombre}". Supabase no confirmó el borrado (posible restricción de permisos). Contacta con soporte.`);
      }
    } catch { }
  };

  return (
    <>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <h2 className="font-bold text-gray-800">🏭 Inventario de Equipos</h2>
          <button onClick={() => setModalNuevoEquipo(true)} className="bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded-xl hover:bg-blue-700 transition-all">+ Añadir equipo</button>
          <span className="text-xs text-gray-500">{equipos.length} equipos</span>
        </div>
        <div className="bg-white rounded-xl shadow overflow-x-auto">
          <table className="w-full text-sm min-w-max">
            <thead className="bg-gray-50 text-gray-600 uppercase text-xs">
              <tr>
                <th className="px-4 py-3 text-left">Estado</th>
                <th className="px-4 py-3 text-left">Nombre</th>
                <th className="px-4 py-3 text-left">Descripción</th>
                <th className="px-4 py-3 text-left">Marca</th>
                <th className="px-4 py-3 text-left">Modelo</th>
                <th className="px-4 py-3 text-left">Nº Serie</th>
                <th className="px-4 py-3 text-left">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {equipos.map(eq => (
                <tr key={eq.id} className="border-t hover:bg-gray-50">
                  {equipoEdit?.id === eq.id ? (
                    <>
                      <td className="px-4 py-2"><button onClick={() => setEquipoEdit(e => ({...e, Activo: !e.Activo}))} className={`w-4 h-4 rounded-full ${equipoEdit.Activo ? "bg-green-500" : "bg-red-500"}`} /></td>
                      <td className="px-4 py-2"><input className="border rounded px-2 py-1 w-full text-xs" value={equipoEdit.Nombre} onChange={e => setEquipoEdit(x => ({...x, Nombre: e.target.value}))} /></td>
                      <td className="px-4 py-2"><input className="border rounded px-2 py-1 w-full text-xs" value={equipoEdit["Descripción"]} onChange={e => setEquipoEdit(x => ({...x, "Descripción": e.target.value}))} /></td>
                      <td className="px-4 py-2"><input className="border rounded px-2 py-1 w-full text-xs" value={equipoEdit.Marca} onChange={e => setEquipoEdit(x => ({...x, Marca: e.target.value}))} /></td>
                      <td className="px-4 py-2"><input className="border rounded px-2 py-1 w-full text-xs" value={equipoEdit.Modelo} onChange={e => setEquipoEdit(x => ({...x, Modelo: e.target.value}))} /></td>
                      <td className="px-4 py-2"><input className="border rounded px-2 py-1 w-full text-xs" value={equipoEdit.Num_serie} onChange={e => setEquipoEdit(x => ({...x, Num_serie: e.target.value}))} /></td>
                      <td className="px-4 py-2 flex gap-2">
                        <button onClick={() => actualizarEquipo(equipoEdit)} className="bg-green-500 text-white text-xs px-2 py-1 rounded">Guardar</button>
                        <button onClick={() => setEquipoEdit(null)} className="bg-gray-300 text-gray-700 text-xs px-2 py-1 rounded">Cancelar</button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="px-4 py-2"><span className={`inline-block w-4 h-4 rounded-full ${eq.Activo ? "bg-green-500" : "bg-red-500"}`} /></td>
                      <td className="px-4 py-2 font-semibold">{eq.Nombre}</td>
                      <td className="px-4 py-2">{eq["Descripción"]}</td>
                      <td className="px-4 py-2">{eq.Marca}</td>
                      <td className="px-4 py-2">{eq.Modelo}</td>
                      <td className="px-4 py-2">{eq.Num_serie}</td>
                      <td className="px-4 py-2 flex gap-2">
                        <button onClick={() => setEquipoEdit(eq)} className="bg-blue-500 text-white text-xs px-2 py-1 rounded">Editar</button>
                        <button onClick={() => eliminarEquipo(eq)} className="bg-red-500 text-white text-xs px-2 py-1 rounded">Eliminar</button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {modalNuevoEquipo && (
        <NuevoEquipoModal
          nuevoEquipo={nuevoEquipo}
          setNuevoEquipo={setNuevoEquipo}
          onGuardar={crearEquipo}
          onCancel={() => setModalNuevoEquipo(false)}
        />
      )}
    </>
  );
};
